export const dropZoneTheme = {
  base: {
    bg: 'palette.transparent',
    borderColor: 'palette.primary.70',
    borderRadius: '12px',
    borderWidth: '1px',
  },
  clickLink: 'palette.primary.40',
  dropText: 'palette.tertiary.90',
  error: {
    bg: 'palette.error.70:0.2',
    borderColor: 'palette.error.70',
    borderRadius: '12px',
    borderWidth: '2px',
  },
  hover: {
    bg: 'palette.primary.30:0.25',
    borderColor: 'palette.primary.20',
    borderRadius: '12px',
    borderWidth: '2px',
  },
  limitationRules: 'palette.tertiary.90',
  methodCode: 'palette.primary.99',
};
